import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api.js';

export type Branding = {
  logo_url: string | null;
  primary_color: string | null;
  signature_html: string | null;
};

export type UpdateBrandingPayload = {
  primary_color?: string;
  signature_html?: string;
};

export function useBranding() {
  return useQuery({
    queryKey: ['admin', 'branding'],
    queryFn: () => apiGet<Branding>('/admin/branding'),
    staleTime: 30_000,
  });
}

export function useUpdateBranding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateBrandingPayload) => apiPatch<Branding>('/admin/branding', input),
    onSuccess: (data) => qc.setQueryData(['admin', 'branding'], data),
  });
}
